import { render, staticRenderFns } from "./PaginationComponent.vue?vue&type=template&id=72804ca2&"
import script from "./PaginationComponent.vue?vue&type=script&lang=js&"
export * from "./PaginationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports